import React, { useContext } from 'react';
import theme from '../theme/theme';
import { calcCompletion, calcGroup, getMatchDetails, trunc } from '../utils';
import { useNavigate, useParams } from "react-router-dom";
import { Avatar, Box, Grid, IconButton, Stack, Tooltip, Typography,
         useMediaQuery } from "@mui/material";
import { globalStore } from '../state/store';
import { BottomNav, ButtonGroupPills, DisplayMatchScore, 
         Header, KnockoutMatch, Questionnaire, TableGroup } from '../components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListUl, faTable } from '@fortawesome/free-solid-svg-icons';

function Predict() {

  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const dayjs = require('dayjs')
  const [state] = useContext(globalStore);
  const { rpage } = useParams();
  const navigate = useNavigate();

  const [page, setPage] = React.useState(rpage) // options: 'groups', 'knockout', 'questions'
  const [pageView, setPageView] = React.useState('matchView')

  return (
    <Box sx={{display: 'flex'}}>

      <Header page={"Predict"} />
      <BottomNav page={"Predict"} />

      <Box component="main" 
      sx={{ flexGrow: 1, mt: 8, p: isSmUp ? 5 : 3, pb: 5, minHeight: '100vh', backgroundColor: theme.palette.grey[200]}}>

        <Box mt={1} mb={5}>
          <Typography variant="h4" align="center" sx={{mb:4}}>
            World Cup 2026
          </Typography>

          <Grid container direction="row" alignItems="center" justifyContent={"center"}>
            <Grid item xs={2}>&nbsp;</Grid>
            <Grid item xs={8} container justifyContent="center">

              <ButtonGroupPills
              selected={page}
              click={setPage}
              buttons={[
                { title: "Group", tiny: calcCompletion("weuro2025", "group", state.prediction, state.matches) + '%', id: "groups" },
                { title: "Knockout", tiny: calcCompletion("weuro2025", "knockout", state.prediction, state.matches) + '%', id: "knockout" },
                { title: "Questions", tiny: calcCompletion("weuro2025", "questionnaire", state.prediction, state.questions) + '%', id: "questions" }
              ]} />

            </Grid>
            <Grid item xs={2} container justifyContent="flex-end">

              {['groups'].includes(page) ?
              <Tooltip title={['matchView'].includes(pageView) ? "Group View" : "Match View"}>
              <IconButton onClick={e => setPageView(['matchView'].includes(pageView) ? 'groupView' : 'matchView')}>
                <FontAwesomeIcon icon={['matchView'].includes(pageView) ? faTable : faListUl} style={{fontSize: '20px', padding: '10px 10px 10px 10px'}} />
              </IconButton>
              </Tooltip>
              : " "}
                
            </Grid>
          </Grid>
        </Box>

        { // GROUP STAGE
        ['groups'].includes(page) ? 

          <Box>

            {['matchView'].includes(pageView) ? // MATCH VIEW

            state.matches
            .filter((m) => m.stage === 'group')
            .sort((a,b) => (a.date > b.date) ? 1 : ((b.date > a.date) ? -1 : 0))
            .map((match) => {
              const { homeTeam, awayTeam, stadium } = getMatchDetails(state, match._id);

              if(homeTeam !== null && awayTeam !== null && stadium !== null) {
                return (
                  <Box key={match._id} onClick={e => navigate('/match/' + match._id)}
                  sx={{ // The "Table Row" styling
                    maxWidth: '920px',
                    margin: 'auto',
                    backgroundColor: theme.palette.primary.contrastText,
                    borderBottom: '1px solid' + theme.palette.grey[200],
                    '&:hover': { /*boxShadow: 'rgba(0, 0, 0, 0.15) 0px 3px 34px 0px',*/
                       backgroundColor: theme.palette.grey[100], cursor: 'pointer' }
                  }}>
                    <Grid container direction="row" alignItems="center" sx={{py:2}}>
  
                      <Grid item md={2} sx={{ display: { xs: 'none', md: 'block'}, px: 2  }}>
                        <Typography variant="body2" color="textSecondary">
                          {dayjs(match.date).format('D MMM. YYYY')}<br/>
                          {dayjs(match.date).format('h:mm A')}
                        </Typography>
                      </Grid>

                      <Grid item md={8} container direction="row" alignItems="center">

                        <Grid item xs={1} sm={2}>
                          <Avatar alt={homeTeam.name} src={homeTeam.flag} sx={{ width: isSmUp ? 34 : 20, height: isSmUp ? 34 : 20, display: 'inline-block' }} />
                        </Grid>
                        <Grid item xs={4} sm={3}>
                          <Typography className="bold" sx={{fontSize: isSmUp ? '16px' : '13px'}}>{homeTeam.name}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                          <DisplayMatchScore matchid={match._id} variant={"predict"} />
                        </Grid>
                        <Grid item xs={4} sm={3}>
                          <Box sx={{ textAlign:'right'}}><Typography className="bold" sx={{fontSize: isSmUp ? '16px' : '13px'}}>{awayTeam.name}</Typography></Box>
                        </Grid>
                        <Grid item xs={1} sm={2}>
                          <Box sx={{ textAlign:'right'}}>
                            <Avatar alt={awayTeam.name} src={awayTeam.flag} sx={{ width: isSmUp ? 34 : 20, height: isSmUp ? 34 : 20, display: 'inline-block' }} />
                          </Box>
                        </Grid>
                        
                      </Grid>

                      <Grid item xs={0} md={2} sx={{ display: { xs: 'none', md: 'block' }, px: 2 }}>
                        <Box sx={{ textAlign:'right'}}>
                          <Typography variant="body2" color="textSecondary">Group {match.groupRef}<br/>{trunc(stadium.name, 17)}</Typography>
                        </Box>
                      </Grid>
  
                    </Grid>
  
                  </Box>
                );
              }
              return null;
            })
            :
            ['groupView'].includes(pageView) ? // GROUPS VIEW

            <Grid container direction="column" alignItems="center">
              <Grid item sx={{my:2}}>
                {state.groups.map((group) => (
                <Box key={group._id} mb={5}>
      
                    <Typography variant="h5" sx={{mb: 3}}>{group.name}</Typography>

                    <Grid container direction="row">
                      <Grid item>
                        <TableGroup 
                        group={calcGroup(group.ref, state.groups, state.teams, state.matches, state.prediction)} 
                        />
                      </Grid>
                    </Grid>
      
                </Box>
                ))}
              </Grid>
            </Grid>
            :''
            }

          </Box>
        
        : // KNOCKOUT STAGE
        ['knockout'].includes(page) && state.groups !== undefined && state.groups.filter((g) => g.ref === "A")[0] !== undefined ? 
        <>
          {/* Original MD+ layout */}
          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            <Grid container direction="row" justifyContent={"space-between"} alignItems="center" sx={{mb:5}}>
              <Grid item>
                <Grid container direction="column">
                  {state.matches.filter((m) => m.stage === 'final8').slice(0,2).map((m) => (
                    <Grid item key={m._id} id={m._id} style={{padding: '50px 0px 50px 0px'}}>
                    <KnockoutMatch
                      matchID={m._id}
                      align="left"
                      desc={"Quarter-final"}
                      homeOptions={state.groups.filter((g) => g.ref === m.homeTeam.substring(1,2))[0].teams}
                      awayOptions={state.groups.filter((g) => g.ref === m.awayTeam.substring(1,2))[0].teams}
                      prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                    />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item>
                <Grid container direction="column">
                  {state.matches.filter((m) => m.stage === 'final4').slice(0,1).map((m) => (
                    <Grid item key={m._id} id={m._id}>
                    <KnockoutMatch
                      matchID={m._id}
                      align="left"
                      desc={"Semi-final"}
                      homeOptions={
                        state.prediction.some((p) => p.matchid === m.homeTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                            [state.prediction.filter((p) => p.matchid === m.homeTeam)[0].homeTeamID, 
                             state.prediction.filter((p) => p.matchid === m.homeTeam)[0].awayTeamID] : [] }
                      awayOptions={
                        state.prediction.some((p) => p.matchid === m.awayTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                            [state.prediction.filter((p) => p.matchid === m.awayTeam)[0].homeTeamID, 
                             state.prediction.filter((p) => p.matchid === m.awayTeam)[0].awayTeamID] : [] }
                      prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                    />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item>
                <Grid container direction="column" spacing={4} style={{paddingTop: '160px'}}>
                  {state.matches.filter((m) => ['final1','final3'].includes(m.stage)).map((m,i) => (
                    <Grid item key={m._id} id={m._id}>
                    <KnockoutMatch
                      matchID={m._id}
                      align="center"
                      desc={i === 0 ? "Final" : "Third place"}
                      homeOptions={
                        state.prediction.some((p) => p.matchid === m.homeTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                            [state.prediction.filter((p) => p.matchid === m.homeTeam)[0].homeTeamID, 
                             state.prediction.filter((p) => p.matchid === m.homeTeam)[0].awayTeamID] : [] }
                      awayOptions={
                        state.prediction.some((p) => p.matchid === m.awayTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                            [state.prediction.filter((p) => p.matchid === m.awayTeam)[0].homeTeamID, 
                             state.prediction.filter((p) => p.matchid === m.awayTeam)[0].awayTeamID] : [] }
                      prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                    />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item>
                <Grid container direction="column">
                  {state.matches.filter((m) => m.stage === 'final4').slice(1).map((m) => (
                    <Grid item key={m._id} id={m._id}>
                    <KnockoutMatch
                      matchID={m._id}
                      align="right"
                      desc={"Semi-final"}
                      homeOptions={
                        state.prediction.some((p) => p.matchid === m.homeTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                            [state.prediction.filter((p) => p.matchid === m.homeTeam)[0].homeTeamID, 
                             state.prediction.filter((p) => p.matchid === m.homeTeam)[0].awayTeamID] : [] }
                      awayOptions={
                        state.prediction.some((p) => p.matchid === m.awayTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                            [state.prediction.filter((p) => p.matchid === m.awayTeam)[0].homeTeamID, 
                             state.prediction.filter((p) => p.matchid === m.awayTeam)[0].awayTeamID] : [] }
                      prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                    />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item>
                <Grid container direction="column">
                  {state.matches.filter((m) => m.stage === 'final8').slice(2).map((m) => (
                    <Grid item key={m._id} id={m._id} style={{padding: '50px 0px 50px 0px'}}>
                    <KnockoutMatch
                      matchID={m._id}
                      align="right"
                      desc={"Quarter-final"}
                      homeOptions={state.groups.filter((g) => g.ref === m.homeTeam.substring(1,2))[0].teams}
                      awayOptions={state.groups.filter((g) => g.ref === m.awayTeam.substring(1,2))[0].teams}
                      prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                    />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>

          {/* SM layout */}
          <Box sx={{ 
            display: { xs: 'none', sm: 'block', md: 'none' },
            '& .MuiDivider-root': { borderColor: 'transparent' },
            '& .match-header': { textAlign: 'center' },
            pb: '50px'  // Add 50px padding at bottom
          }}>
            <Grid container spacing={2} sx={{ minHeight: '70vh' }}>
              {/* Quarter-finals column */}
              <Grid item sm={4}>
                <Typography variant="h6" align="center" gutterBottom>Quarter-finals</Typography>
                {state.matches
                  .filter((m) => m.stage === 'final8')
                  .map((m) => (
                    <Box key={m._id} sx={{ mb: 2 }}>
                      <KnockoutMatch
                        matchID={m._id}
                        align="center"
                        desc={"Quarter-final"}
                        homeOptions={state.groups.filter((g) => g.ref === m.homeTeam.substring(1,2))[0].teams}
                        awayOptions={state.groups.filter((g) => g.ref === m.awayTeam.substring(1,2))[0].teams}
                        prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                      />
                    </Box>
                ))}
              </Grid>

              {/* Semi-finals column */}
              <Grid item sm={4} container direction="column">
                <Grid item>
                  <Typography variant="h6" align="center" gutterBottom>Semi-finals</Typography>
                </Grid>
                <Grid item container alignItems="center" sx={{ flex: 1 }}>
                  {state.matches
                    .filter((m) => m.stage === 'final4')
                    .map((m) => (
                      <Box key={m._id} sx={{ mb: 3, width: '100%' }}>
                        <KnockoutMatch
                          matchID={m._id}
                          align="center"
                          desc={"Semi-final"}
                          homeOptions={
                            state.prediction.some((p) => p.matchid === m.homeTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                              [state.prediction.filter((p) => p.matchid === m.homeTeam)[0].homeTeamID, 
                               state.prediction.filter((p) => p.matchid === m.homeTeam)[0].awayTeamID] : [] }
                          awayOptions={
                            state.prediction.some((p) => p.matchid === m.awayTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                              [state.prediction.filter((p) => p.matchid === m.awayTeam)[0].homeTeamID, 
                               state.prediction.filter((p) => p.matchid === m.awayTeam)[0].awayTeamID] : [] }
                          prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                        />
                      </Box>
                  ))}
                </Grid>
              </Grid>

              {/* Finals column */}
              <Grid item sm={4} container direction="column">
                <Grid item>
                  <Typography variant="h6" align="center" gutterBottom>Finals</Typography>
                </Grid>
                <Grid item container alignItems="center" sx={{ flex: 1 }}>
                  {state.matches
                    .filter((m) => ['final1','final3'].includes(m.stage))
                    .map((m, i) => (
                      <Box key={m._id} sx={{ mb: 3, width: '100%' }}>
                        <KnockoutMatch
                          matchID={m._id}
                          align="center"
                          desc={i === 0 ? "Final" : "Third place"}
                          homeOptions={
                            state.prediction.some((p) => p.matchid === m.homeTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                              [state.prediction.filter((p) => p.matchid === m.homeTeam)[0].homeTeamID, 
                               state.prediction.filter((p) => p.matchid === m.homeTeam)[0].awayTeamID] : [] }
                          awayOptions={
                            state.prediction.some((p) => p.matchid === m.awayTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                              [state.prediction.filter((p) => p.matchid === m.awayTeam)[0].homeTeamID, 
                               state.prediction.filter((p) => p.matchid === m.awayTeam)[0].awayTeamID] : [] }
                          prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                        />
                      </Box>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Box>

          {/* XS layout */}
          <Box sx={{ 
            display: { xs: 'block', sm: 'none' },
            pb: '50px'
          }}>
            <Stack spacing={4}>
              {/* Quarter-finals section - 2x2 grid */}
              <Box>
                <Typography variant="h6" align="center" gutterBottom>Quarter-finals</Typography>
                <Grid container spacing={1}>
                  {state.matches
                    .filter((m) => m.stage === 'final8')
                    .map((m, index) => (
                      <Grid item xs={6} key={m._id}>
                        <Box sx={{ mb: 2 }}>
                          <KnockoutMatch
                            matchID={m._id}
                            align="center"
                            desc={"Quarter-final"}
                            homeOptions={state.groups.filter((g) => g.ref === m.homeTeam.substring(1,2))[0].teams}
                            awayOptions={state.groups.filter((g) => g.ref === m.awayTeam.substring(1,2))[0].teams}
                            prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                          />
                        </Box>
                      </Grid>
                  ))}
                </Grid>
              </Box>

              {/* Semi-finals section - 1x2 grid */}
              <Box>
                <Typography variant="h6" align="center" gutterBottom>Semi-finals</Typography>
                <Grid container spacing={2}>
                  {state.matches
                    .filter((m) => m.stage === 'final4')
                    .map((m) => (
                      <Grid item xs={6} key={m._id}>
                        <Box sx={{ mb: 3 }}>
                          <KnockoutMatch
                            matchID={m._id}
                            align="center"
                            desc={"Semi-final"}
                            homeOptions={
                              state.prediction.some((p) => p.matchid === m.homeTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                                [state.prediction.filter((p) => p.matchid === m.homeTeam)[0].homeTeamID, 
                                 state.prediction.filter((p) => p.matchid === m.homeTeam)[0].awayTeamID] : [] }
                            awayOptions={
                              state.prediction.some((p) => p.matchid === m.awayTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                                [state.prediction.filter((p) => p.matchid === m.awayTeam)[0].homeTeamID, 
                                 state.prediction.filter((p) => p.matchid === m.awayTeam)[0].awayTeamID] : [] }
                            prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                          />
                        </Box>
                      </Grid>
                  ))}
                </Grid>
              </Box>

              {/* Finals section - centered */}
              <Box>
                <Typography variant="h6" align="center" gutterBottom>Finals</Typography>
                <Grid container justifyContent="center">
                  {state.matches
                    .filter((m) => ['final1','final3'].includes(m.stage))
                    .map((m, i) => (
                      <Grid item xs={6} key={m._id}>
                        <Box sx={{ mb: 3 }}>
                          <KnockoutMatch
                            matchID={m._id}
                            align="center"
                            desc={i === 0 ? "Final" : "Third place"}
                            homeOptions={
                              state.prediction.some((p) => p.matchid === m.homeTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                                [state.prediction.filter((p) => p.matchid === m.homeTeam)[0].homeTeamID, 
                                 state.prediction.filter((p) => p.matchid === m.homeTeam)[0].awayTeamID] : [] }
                            awayOptions={
                              state.prediction.some((p) => p.matchid === m.awayTeam && Boolean(p.homeTeamID) && Boolean(p.awayTeamID)) ?
                                [state.prediction.filter((p) => p.matchid === m.awayTeam)[0].homeTeamID, 
                                 state.prediction.filter((p) => p.matchid === m.awayTeam)[0].awayTeamID] : [] }
                            prediction={state.prediction.filter((p) => p.matchid === m._id)[0]}
                          />
                        </Box>
                      </Grid>
                  ))}
                </Grid>
              </Box>
            </Stack>
          </Box>
        </>
        : // QUESTIONNAIRE
        ['questions'].includes(page) ? 

        <Box sx={{ textAlign: 'center', width: '100%'}}>
        <Grid container direction="column" justifyContent="center" alignItems="center">
          <Grid item>
          <Box sx={{ width: isMdUp ? '720px' : isSmUp ? '440px' : '320px', textAlign: 'left', my: 1, mb: 6 }}>

            <Questionnaire />

          </Box>
          </Grid>
        </Grid>
        </Box>
        : '' }
        
      </Box>

    </Box>
  );
}

export default Predict;
